import type {LocationsFiltersType, LocationPointType, VenueType} from '~/utils/types/account/locations/types'

export const initLocationsFilters = (): LocationsFiltersType => ({
    name: null,
    city: null,
    country: null,
    active: true,
})

export const initLocationPoint = (): LocationPointType => ({
    cityId: null,
    cityName: null,
    countryId: null,
    countryName: null,
    id: null,
    latitude: null,
    name: {
        en: null,
    },
    longitude: null,
    postalCode: null,
    active: true,
    street: {
        en: null,
    },
})

export const initVenue = (): VenueType => ({
    id: null,
    street: {
        en: null,
    },
    name: {
        en: null,
    },
    supplierId: null,
    supplierSpecificCode: null,
    postalCode: null,
    active: true,
    longitude: null,
    latitude: null,
    types: [],
})
